import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { CheckupTypeItemsListAliases, FragmentNames } from '../../codegen';
import './checkup-type-list-controller.css';
import { FetchAPI, FieldAPI, TextAPI, TextFontSize } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

@Controller({ component: CheckupTypeItemsListAliases.LAYOUT_CHECKUP_TYPE_ITEMS_LIST, fragment: FragmentNames.CHECKUP_TYPE_ITEMS_LIST })
export default class CheckupListController extends BaseController {

  @OnMount({ target: CheckupTypeItemsListAliases.TEXT_CHECKUP_TYPE_LIST_TITLE })
  handleMountListTitle(event: MountEvent): void {
    const title = event?.target as TextAPI;
    const isCard = this.context.get('isCard') as boolean;
    if (isCard && title) {
      title.setSize(TextFontSize.MEDIUM);
    }
  }

  @OnMount({ target: CheckupTypeItemsListAliases.FETCH_CHECKUP_TYPE_ITEMS_LIST })
  handleMountFetchCheckupList(event: MountEvent): void {
    const fetchCheckupTypeItemsListApi = event?.target as FetchAPI;
    const parameters = {
      checkupCode: this.context.get('checkupCode') as string,
      personCode: this.context.get('personCode') as string,
      selectedDate: this.context.get('expectedDate') ?? '',
      type: this.context.get('checkupType') as string,
    } as Record<string, Value>;

    fetchCheckupTypeItemsListApi.setParameters(parameters);
    fetchCheckupTypeItemsListApi.forceFetch();
  }

  @OnMount({ target: [
    CheckupTypeItemsListAliases.FIELD_DESKTOP_CHECKUP_TYPE_ITEM_EXPECTED_DATE,
    CheckupTypeItemsListAliases.FIELD_MOBILE_CHECKUP_TYPE_ITEM_EXPECTED_DATE,
  ] })
  handleExpectedDate(event: MountEvent): void {
    const textField = event?.target as FieldAPI;
    if (!this.context.get('expectedDate')) {
      textField.setVisible(false);
    }
  }
}
